import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { FEATURE_FLAGS } from "~/services/featureFlags/constants";
import { useFeatureFlag } from "~/services/featureFlags/provider";

/**
 * Every `/docs` surface is the Indigo Doc POC sandbox (specs/indigo-doc/poc.md):
 * behind `enable-indigo-doc-sandbox`, which is on in dev only, and never linked
 * from the nav.
 */
export const SandboxGate: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { isEnabled, loading } = useFeatureFlag(
    FEATURE_FLAGS.INDIGO_DOC_SANDBOX,
  );
  if (loading) return null;
  if (!isEnabled) return <Navigate to="/not-found" replace />;
  return <>{children}</>;
};
